const REGEX_EDIT_SUMMARY_PARTS = /(?:\/\*([^*]+)\*\/)?(.+)?/;

export default REGEX_EDIT_SUMMARY_PARTS;



// WEBPACK FOOTER //
// ./src/components/timeline/revision/edit-summary-parts.js